import React, { useEffect, useContext, useRef } from "react";
import UITopic from "ui/UITopic";
import UIDialog from "ui/UIDialog";
import { useHistory } from "react-router-dom";

import GlobalContext from "contexts/context";
import { useLiveSubscriptions, useLiveDialogs } from "hooks/dbHooks";

const UITopicList = (props) => {
  const { globalState } = useContext(GlobalContext);
  const liveSubscriptions = useLiveSubscriptions(props.db);
  const liveDialogs = useLiveDialogs(props.db);

  const topicList = useRef([]);
  const dialogList = useRef([]);

  let history = useHistory();
  let targetdialog = sessionStorage.getItem("targetdialog");
  let targetmtopic = sessionStorage.getItem("targetmtopic");

  useEffect(() => {
    if (targetmtopic) {
      liveSubscriptions.map((sub) => {
        if (sub.mtopic && sub.mtopic === targetmtopic) {
          sessionStorage.removeItem("targetmtopic");
          sessionStorage.removeItem("targetdialog");
          // if targetmtopic exists, navigate directly to that topic
          history.push("/UIMessageList", {
            subscription: sub,
          });
        }
      });
    } else if (targetdialog) {
      liveDialogs.map((dialog) => {
        if (dialog.peer && dialog.peer === targetdialog) {
          sessionStorage.removeItem("targetdialog");
          // if targetdialog exists, navigate directly to that dialog
          history.push("/UIMessageList", {
            dialog: dialog,
          });
        }
      });
    }

    return () => {};
  }, [liveSubscriptions, liveDialogs, targetdialog, targetmtopic]);

  let content = (
    <div className="UI-topic-list-container">
      <div id="list_holder" className="UI-topic-list hide-scrollbar">
        {liveDialogs &&
          (dialogList.current = liveDialogs
            .map((dialog) =>
              globalState.persona ? (
                globalState.persona.mpersona === dialog.mpersona && (
                  <UIDialog
                    key={dialog.mdialog}
                    dialog={dialog}
                    share={props.share}
                  ></UIDialog>
                )
              ) : (
                <UIDialog
                  key={dialog.mdialog}
                  dialog={dialog}
                  share={props.share}
                ></UIDialog>
              )
            )
            .filter((r) => r))}
        {liveSubscriptions &&
          (topicList.current = liveSubscriptions
            .map((sub) =>
              globalState.persona ? (
                globalState.persona.mpersona === sub.mpersona && (
                  <UITopic
                    key={sub.mtopic}
                    sub={sub}
                    share={props.share}
                  ></UITopic>
                )
              ) : (
                <UITopic
                  key={sub.mtopic}
                  sub={sub}
                  share={props.share}
                ></UITopic>
              )
            )
            .filter((r) => r))}
      </div>
    </div>
  );

  return content;
};

export default React.memo(UITopicList, (prevProps, nextProps) => {
  console.log("UITopicList props ", nextProps);
  return prevProps === nextProps;
});
